module.exports = __webpack_public_path__ + "ke.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/ke.svg
// module id = 887
// module chunks = 0